<template>
    <div>
        <div class="head">
            <div class="logo">
                <img src="@/imgs/logo.png" style="width:50px;">
                <div class="title">湘雅博爱康复医院康复平台</div>
            </div>
            <div class="other">
                <el-dropdown trigger="click" style="color:white;cursor: pointer;" @command="handleCommand">
                    <!-- 用户名 -->
                    <div class="item">
                        <span>{{userName}}&nbsp;&nbsp; 欢迎登录！<i class="el-icon-arrow-down el-icon--right"></i></span>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="1">修改密码</el-dropdown-item>
                        <el-dropdown-item command="2">退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <NewPwd ref="nPwd" @handleEditPwdClick="handleEditPwdClick"/>
    </div>

</template>

<script>
    import { logOut,updatePwd } from '@/api/api';
    import NewPwd from '@/pages/login/newpwd.vue';
    import { sha256 } from "@/utilities";

    export default {
        data() {
            return {
                userName: sessionStorage.getItem('userName')
            }
        },
        components:{
            NewPwd
        },
        methods: {
            handleEditPwdClick(data){
                this.ajaxUpdatePwd(data);
            },
            handleCommand(command) {
                if( command == '1' ) this.handleEditPwd();
                else this.handleLogOut();
            },
            handleLogOut(){
                this.$confirm('是否要退出当前账号?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(() => {
                        this.ajaxLogOut();
                    }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
            handleEditPwd(){
                this.$refs.nPwd.open();
            },
            async ajaxLogOut(){
                try {
                    const result = await logOut();
                    if( result.code == 0 ){
                        this.$message({
                            type: 'success',
                            message: '退出成功'
                        })
                        this.$router.push('/');
                    }
                } catch (error) {
                    console.log(error);
                }
            },
            async ajaxUpdatePwd(data){
                try {
                    let userNo=sessionStorage.getItem('userNo');
                    let pwd=data.pwd;
                    let pass=data.pass;
                    let pwd256=await sha256(userNo+'||'+pwd);
                    let pass256=await sha256(userNo+'||'+pass);
                    const result = await updatePwd({
                        oldPwd: pwd256,
                        newPwd: pass256
                    });
                    if( result.code == 0 ){
                        this.$notify({
                            title: '提示',
                            type: 'success',
                            message: '修改成功,请重新登录~'
                        });
                        this.$refs.nPwd.resetForm("ruleForm");
                        this.$router.push('/');
                    }else{
                        this.$notify({
                            title: '提示',
                            type: 'error',
                            message: result.message
                        });
                        this.$refs.nPwd.resetForm("ruleForm");
                    }
                } catch (error) {
                    console.log(error);
                }
            },
        },
    }
</script>

<style lang="scss">

    .head {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 999;
        background: #ffffff;
        box-sizing: border-box;
        width: 100%;
        padding: 0 20px;
        height: 7.21%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        -webkit-box-shadow: 1px 2px 3px rgba(0, 0, 0, 0.1);
        box-shadow: 1px 2px 3px rgba(0, 0, 0, 0.1);
    }

    .head i {
        color: #333;
    }

    .other {
        display: flex;
        height: 100%;
        align-items: center;
    }

    .other .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
        width: 13rem;
        cursor: pointer;
        margin-right: 10%;
    }

    .other .item:nth-child(1) {
        width: 13rem;
    }

    .other .item:nth-child(2) {
        width: 52px;
    }

    .other .item:nth-child(3) {
        width: 52px;
    }

    .other .item span {
        font-size: 14px;
        color: #333;
        opacity: 0.8;
    }

    .time {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #666;
    }

    .time span:first-child {
        font-weight: bold;
    }

    .logo {
        display: flex;
        align-items: center;
    }

    .logo .title {
        color: #333;
        font-size: 16px;
        font-weight: bold;
        margin-left: 10px;
    }

    #pwd {
        width: 796px;
        height: 100%;
        margin: 0px auto;
    }

    #pwd-row {
        width: 335px;
    }

    .dialog-footer {
        text-align: center;
        margin-top: -40px;
    }

    #pwd .el-dialog {
        width: 33% !important;
    }
</style>



// WEBPACK FOOTER //
// src/pages/head/head.vue